export const LOGO=require('../assets/images/logo.png');
export const SITE_TITLE="Aeri Tech";
export const LINKEDIN ="https://www.linkedin.com/company/aeritech";
export const FACEBOOK = "https://www.facebook.com/aeritech";
export const TWITTER="https://twitter.com/aeritech";
export const INSTAGRAM = "https://www.instagram.com";
export const GOOGLE = "https://plus.google.com/u/1/115592892026834873332";